$(function () {
  $(document).on('click', '.js-project-tab-link', function () {
    $('.js-project-tab-link').removeClass('-current');
    $(this).addClass('-current');
    var tabName = $(this).data('tab-name');
    $('.js-project-tab').each(function (index, object) {
      if ($(object).data('tab-name') === tabName) {
        $(object).addClass('-current');
      } else {
        $(object).removeClass('-current');
      }
    });
  });

  $(document).on('click', '.js-active-report-description-button', function () {
    var parent = $(this).parent();
    parent.siblings('.js-active-report-short').hide();
    parent.siblings('.js-active-report-full').show();
    $(this).hide();
  });

  $('.js-active-report-content a').each(function (index, link) {
    $(link)
      .attr('target', '_blank')
      .attr('rel', 'nofollow');
  });

  if (window.location.hash) {
    var target = window.location.hash.replace('#', '');
    $('#js-tab-' + target).click();
    var tabTop = $('#tab-' + target).offset().top;
    var headerHeight = $('.l-header').height();
    var tabHeight = $('.p-fundraise-project-detail__tabs').height();
    var contentAreaPaddingTop = parseInt($('.l-fundraise-detail__body-content').css('padding-top').replace('px', ''));
    $('html').scrollTop(tabTop - headerHeight - tabHeight - contentAreaPaddingTop);
  }
});
